module.exports = __webpack_public_path__ + "img/logo-short.d28ed236.png";